<div class="ne-container {outroClass}"
     in:customFly="{enter}"
     out:customFly="{exit}"
     on:outrostart="{() => outroClass = 'outro'}"
     on:outroend="{() => outroClass = ''}" >
  <EditPage />
</div>

<style>
  .ne-container {
    height: 100%;
    width: 100%;
  }

  .outro {
    height: 0;
  }
</style>

<script>
  import { tick } from 'svelte';
  import { store, router } from '../stores';
  import { customFly } from '../lib/transitions';
  import EditPage from '../pages/EditPage.html';

  let enter;
  let exit;
  let outroClass = '';

  $: direction = $router.previous === 'layout' ? 1 : -1;
  $: enter = { x: direction * 200, duration: 250, delay: 251 };
</script>
